import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import * as ipaddr from "ipaddr.js";

export default async function createIpDynamoMasivo(status) {
  // const endpoint = localStorage.getItem('endpoint')
  const isCidr = require("is-cidr");

  if (isCidr(status.ip + "/36") === 4) {
    status.ip =
      ipaddr.IPv4.networkAddressFromCIDR(status.ip).toNormalizedString() +
      status.ip.substring(status.ip.indexOf("/"), status.ip.length);
  }

  const url = "https://api.almeraim.com/controlexternalform";

  const js = JSON.stringify(status);

  try {
    const config = { method: "POST", headers: {}, mode: "cors", body: js };
    const response = await fetch(url, config);
    const json = await response.json();

    if (json.message === "ok") {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
    }
  } catch (error) {
    console.log("Error" + error);
  }
}
